export default __webpack_public_path__ + "static/media/employeetracker.9b15422e.jpg";